import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Moon, Sun, Menu, X } from 'lucide-react';
export function Header() {
  const [darkMode, setDarkMode] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useEffect(() => {
    const isDark = localStorage.getItem('darkMode') === 'true';
    setDarkMode(isDark);
    if (isDark) {
      document.documentElement.classList.add('dark');
    }
  }, []);
  const toggleDarkMode = () => {
    const newMode = !darkMode;
    setDarkMode(newMode);
    localStorage.setItem('darkMode', String(newMode));
    document.documentElement.classList.toggle('dark');
  };
  return <header className="border-b border-border bg-background sticky top-0 z-50" data-id="element-85">
      <div className="container mx-auto px-4 py-4" data-id="element-86">
        <div className="flex items-center justify-between" data-id="element-87">
          <Link to="/" className="text-2xl font-bold text-primary hover:opacity-80 transition-opacity" data-id="element-88">
            Hpppy.com
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-6" data-id="element-89">
            <Link to="/financial" className="text-sm font-medium hover:text-primary transition-colors" data-id="element-90">
              Financial
            </Link>
            <Link to="/text-tools" className="text-sm font-medium hover:text-primary transition-colors" data-id="element-91">
              Text Tools
            </Link>
            <Link to="/fun" className="text-sm font-medium hover:text-primary transition-colors" data-id="element-92">
              Fun & Social
            </Link>
            <Link to="/developer" className="text-sm font-medium hover:text-primary transition-colors" data-id="element-93">
              Developer
            </Link>
            <Link to="/fun/secret-santa" className="text-sm font-medium text-primary hover:opacity-80 transition-opacity" data-id="element-94">
              🎅 Secret Santa
            </Link>
            <button onClick={toggleDarkMode} className="p-2 rounded-md hover:bg-accent transition-colors" aria-label="Toggle dark mode" data-id="element-95">
              {darkMode ? <Sun className="w-5 h-5" data-id="element-96" /> : <Moon className="w-5 h-5" data-id="element-97" />}
            </button>
          </nav>

          {/* Mobile Menu Button */}
          <div className="flex items-center gap-2 md:hidden" data-id="element-98">
            <button onClick={toggleDarkMode} className="p-2 rounded-md hover:bg-accent transition-colors" aria-label="Toggle dark mode" data-id="element-99">
              {darkMode ? <Sun className="w-5 h-5" data-id="element-100" /> : <Moon className="w-5 h-5" data-id="element-101" />}
            </button>
            <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="p-2 rounded-md hover:bg-accent transition-colors" aria-label="Toggle menu" data-id="element-102">
              {mobileMenuOpen ? <X className="w-5 h-5" data-id="element-103" /> : <Menu className="w-5 h-5" data-id="element-104" />}
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {mobileMenuOpen && <nav className="md:hidden mt-4 pb-4 flex flex-col gap-3" data-id="element-105">
            <Link to="/financial" className="text-sm font-medium hover:text-primary transition-colors py-2" onClick={() => setMobileMenuOpen(false)} data-id="element-106">
              Financial
            </Link>
            <Link to="/text-tools" className="text-sm font-medium hover:text-primary transition-colors py-2" onClick={() => setMobileMenuOpen(false)} data-id="element-107">
              Text Tools
            </Link>
            <Link to="/fun" className="text-sm font-medium hover:text-primary transition-colors py-2" onClick={() => setMobileMenuOpen(false)} data-id="element-108">
              Fun & Social
            </Link>
            <Link to="/developer" className="text-sm font-medium hover:text-primary transition-colors py-2" onClick={() => setMobileMenuOpen(false)} data-id="element-109">
              Developer
            </Link>
            <Link to="/fun/secret-santa" className="text-sm font-medium text-primary hover:opacity-80 transition-opacity py-2" onClick={() => setMobileMenuOpen(false)} data-id="element-110">
              🎅 Secret Santa
            </Link>
          </nav>}
      </div>
    </header>;
}